module.exports = __webpack_public_path__ + "img/InteligentLearning.bca0dce0.jpg";